import _objectSpread from "/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import * as React from 'react';
import FormCheck from './FormCheck';
import { jsx as _jsx } from "react/jsx-runtime";
var Switch = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(FormCheck, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    type: "switch"
  }));
});
Switch.displayName = 'Switch';
export default Object.assign(Switch, {
  Input: FormCheck.Input,
  Label: FormCheck.Label
});